const API_BASE = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  ? 'http://localhost:5001/api'
  : 'https://dpass.architectcrm.in/api';

export const apiFetch = async (endpoint, options = {}) => {
  const token = localStorage.getItem('authToken');

  const headers = {
    ...(options.headers || {}),
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers,
  });

  // JWT expired / invalid
  if (response.status === 401) {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');

    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }

    throw new Error('Session expired');
  }

  return response;
};